<div class="wrapper-modal">
  <div nxLayout="grid" *ngIf="!evrotrustService.isLoading"> 
    <div nxRow  nxRow nxRowJustify="center"> 
      <div nxCol="12">
        <nx-message context="error" *ngIf="isHaveValidAccountErrorMessage===true"> {{'evrotrust.create-profile-error' | translate}} </nx-message>
        <!-- <nx-message context="error" *ngIf="messageText?.type==='error'"> {{messageText.text}} </nx-message> -->
      </div>
    </div>
  
      <div nxRow nxRowJustify="center">
        <div nxCol="12">
          <h2 class="nx-font-weight-light modal-title">
              {{'evrotrust.sign-policy' | translate}}
          </h2>
        </div>
      </div>
  
      <div nxRow nxRowJustify="center" style="display: grid;">
          <div  nxCol="12">
              <button (click)="signDocuments()" nxButton="primary" type="submit">
                  {{'evrotrust.continue' | translate}}
             </button>
          </div>
      </div>
  
      <div nxRow nxRowJustify="center">
          <div nxCol="12" >
              <h3 *ngIf="!(isHaveValidAccount$)" type="button" (click)="downloadEvrotrustModal()" class="nx-font-weight-light sub-title">
            {{'evrotrust.create-profile' | translate}}
            </h3 >
          </div>
        </div>
  </div>


  <div nxLayout="grid" *ngIf="evrotrustService.isLoading || messageText?.type==='error'" class="loading-wrapper">
    <div nxRow nxRowJustify="center" class="loading"  *ngIf="evrotrustService.isLoading">
      <qbe-animation-loader
      name="apartment-building"
      [width]="'64px'"
    ></qbe-animation-loader>    </div>
      <div  nxRow rowJustify="center" style="max-width: 1120px;">
        <h2 class="nx-font-weight-light messages-title" *ngIf="messageText?.type==='message'">
          {{messageText.text | translate}}
        </h2>
      </div>
      <div nxRow rowJustify="center" style="display: grid;" *ngIf="showWithdrawn == true && messageText?.type==='message' && this.clickedWithdrawn==false">
        <div  nxCol="12">
            <button (click)="withdrownnDocuments()" nxButton="primary" type="submit">
              {{'evrotrust.withdraw' | translate}}    
             </button>
        </div>
    </div>
  </div>
</div>

